var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHtlPayTvFilled = function SvgHtlPayTvFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.5 14h-5a.5.5 0 0 1 0-1h2v-1H3a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H8.5v1h2a.5.5 0 0 1 0 1ZM6.405 7.632a.5.5 0 0 0-.5.5c0 .751.638 1.335 1.625 1.487V10a.5.5 0 0 0 1 0v-.387a1.737 1.737 0 0 0 1.625-1.587 1.364 1.364 0 0 0-.687-1.195A3.489 3.489 0 0 0 8.1 6.397c-.719-.1-.979-.373-.979-.529 0-.456.57-.524.91-.524.213 0 .909.038.909.524a.5.5 0 0 0 1 0 1.53 1.53 0 0 0-1.41-1.482V4a.5.5 0 1 0-1 0v.383a1.5 1.5 0 0 0-1.408 1.485c0 .607.483 1.325 1.839 1.519.793.114 1.195.329 1.195.639s-.43.629-1.124.629c-.694 0-1.125-.272-1.125-.524a.5.5 0 0 0-.507-.499h.005Z"
  })));
};
export default SvgHtlPayTvFilled;